import { useState } from "react";

import { GqlMedia } from "~/__generated__";
import MediaList from "~/modules/media/components/MediaList/MediaList";
import MediaPreviewDialog from "~/modules/media/components/MediaPreviewDialog/MediaPreviewDialog";

type Props = {
    media: GqlMedia[];
    onDelete?: (deletedMediaId: string) => void;
};

export function ObservationMediaDisplay({ media, onDelete }: Props) {
    const [selectedMedia, setSelectedMedia] = useState<GqlMedia | null>(null);

    const handleDelete = (media: { id: string }) => {
        onDelete?.(media.id);
        setSelectedMedia(null);
    };

    return (
        <>
            <MediaList medias={media || []} onMediaClick={setSelectedMedia} />
            <MediaPreviewDialog
                media={selectedMedia}
                open={Boolean(selectedMedia)}
                onClose={() => setSelectedMedia(null)}
                onDelete={onDelete !== undefined ? handleDelete : undefined}
            />
        </>
    );
}
